import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import SideModal from "../../Components/SideModal";
import Table from "../../Components/EStamp/Table";
import ViewStampDetails from "../../Components/EStamp/ViewDetails";
import SummaryCards from "../../Components/EStamp/SummaryCards";
import TableNew from "../../Components/EStamp/TableNew";
import { toast } from "react-toastify";
import SwitchStampModal from "../../Components/EStamp/SwitchStampModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";

const FILTER_TYPES = {
    ALL: 'all',
    EXHAUSTED: 'exhausted'
};
const StampPaperListingNew = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty,
    );
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([]);
    const [viewDetails, setViewDetails] = useState(false);
    const [summaryData, setSummaryData] = useState();
    const [isSwitchStamp, setIsSwitchStamp] = useState(false);
    const properties = useSelector((state) => state.PropertyReducer.property);
    const [selectedProperty, setSelectedProperty] = useState(property);
    const [activeFilter, setActiveFilter] = useState(FILTER_TYPES.ALL);
    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/client/stamp/list`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) {
            setApiData([]);

        } else {
            const data = res?.data || [];
            setApiData(data);
            let properties = res?.properties || [];

            const hasAllProperties = properties.some(p => p.id === 0);

            if (!hasAllProperties) {
                properties = [
                    {
                        id: 0,
                        gId: "KIPINN",
                        name: "All Properties"
                    },
                    ...properties
                ];
            }

            setFilteredProperties(properties);
            // setFilteredProperties(res?.properties);
            setSummaryData(res?.stats || []);
        }
    };

    const getError = () => {
        setApiData([]);
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getListMutate();
        }, 50);
        return () => clearTimeout(handler);
    }, [getListMutate]);

    // const filteredData = selectedProperty?.id
    //     ? apiData?.filter(
    //         (item) => item?.propId === selectedProperty?.id
    //     )
    //     : apiData;
    const getFilteredData = () => {
        let filteredData = apiData;

        if (selectedProperty?.id) {
            filteredData = filteredData.filter(
                (item) => item?.propId === selectedProperty?.id
            );
        }

        if (activeFilter === FILTER_TYPES.EXHAUSTED) {
            filteredData = filteredData.filter(
                (item) => item?.available === 0
            );
        }

        return filteredData;
    };

    const filteredData = getFilteredData();

    const getFilterCount = (filterType) => {
        let dataToCount = apiData;

        if (selectedProperty?.id) {
            dataToCount = dataToCount.filter(
                (item) => item?.propId === selectedProperty?.id
            );
        }

        if (filterType === FILTER_TYPES.ALL) {
            return dataToCount.length;
        } else if (filterType === FILTER_TYPES.EXHAUSTED) {
            return dataToCount.filter((item) => item?.available === 0).length;
        }
        return 0;
    };

    //------- Switch Stamp  -------
    const switchStampFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/client/stamp/shift`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const switchStampSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg);
            setIsSwitchStamp(false);
            getListMutate();
        } else {
            toast.error(data?.data?.msg);
        }
    };

    const switchStampError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: switchStampLoading, mutate: switchStampMutate } =
        useMutation(switchStampFunction, {
            onSuccess: switchStampSuccess,
            onError: switchStampError,
        });

    const handleSwitchStampClose = () => {
        setIsSwitchStamp(false);
    };

    const handlePropertySelect = (property) => {
        setSelectedProperty(property);
        setActiveFilter(FILTER_TYPES.ALL);
    };
    const handleFilterClick = (filterType) => {
        setActiveFilter(filterType);
    };
    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {"Stamp Papers"}
                        <Underline />
                    </BoxTitle>
                </BoxHead>
                {(isLoading || isRefetching) && (
                    <SummarySkeletonLoading count={3} />
                )}
                {!error && !isLoading && data && summaryData && (
                    <SummaryCards summaryData={summaryData} />
                )}

                <FilterTableWrapper>
                    <FilterWrapper>
                        <div className="flex items-center justify-between w-full">
                            {/* <Text>
                                Total records:{" "}
                                <span className="font-semibold">
                                    {apiData?.length || 0}
                                </span>
                            </Text> */}
                            <div className="flex items-center gap-3">
                                <div className="flex items-center bg-slate-100 rounded-xl p-1">
                                    <SegmentButton
                                        active={activeFilter === FILTER_TYPES.ALL}
                                        count={getFilterCount(FILTER_TYPES.ALL)}
                                        onClick={() => handleFilterClick(FILTER_TYPES.ALL)}
                                    >
                                        All
                                    </SegmentButton>

                                    <SegmentButton
                                        active={activeFilter === FILTER_TYPES.EXHAUSTED}
                                        count={getFilterCount(FILTER_TYPES.EXHAUSTED)}
                                        onClick={() => handleFilterClick(FILTER_TYPES.EXHAUSTED)}
                                    >
                                        Exhausted
                                    </SegmentButton>
                                </div>
                            </div>
                            <div className="flex ustify-end items-center ml-auto">
                                <PropertiesFilterDropdown
                                    properties={filteredProperties}
                                    selectedProperty={selectedProperty}
                                    onPropertySelect={handlePropertySelect}
                                    placeholder="Select Property"
                                    className="min-w-[200px] w-full md:w-[220px]"
                                />
                            </div>
                        </div>
                    </FilterWrapper>
                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <TableNew
                                apiData={error ? [] : filteredData}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                                setViewDetails={setViewDetails}
                                setIsSwitchStamp={setIsSwitchStamp}
                            />
                            {(!error && filteredData?.length === 0 && !isLoading) && (
                                <NotFoundModel />
                            )}
                        </TableWrapper>
                    )}
                </FilterTableWrapper>


                {(isLoading || isRefetching) && <Loading />}
                <SideModal
                    isOpen={viewDetails}
                    onClose={() => setViewDetails(false)}
                >
                    <ViewStampDetails
                        setViewDetails={setViewDetails}
                        selectedData={selectedData}
                    />
                </SideModal>
                <SideModal
                    isOpen={isSwitchStamp}
                    onClose={() => setIsSwitchStamp(false)}
                >
                    <SwitchStampModal
                        setIsSwitchStamp={setIsSwitchStamp}
                        selectedData={selectedData}
                        handleClose={handleSwitchStampClose}
                        switchStampLoading={switchStampLoading}
                        switchStampMutate={switchStampMutate}
                        properties={properties || []}
                    />
                </SideModal>
            </BoxContainer>
        </>
    );
};

const SegmentButton = ({ active, count, children, ...props }) => (
    <button
        {...props}
        className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-[transform,box-shadow] duration-150 ease-out
      ${active
                ? "bg-white text-slate-900 shadow-sm scale-[1.02]"
                : "text-slate-600 hover:text-slate-800 hover:scale-[1.01]"
            }`}
    >
        <span>{children}</span>

        {typeof count === "number" && (
            <span
                className={`min-w-[20px] h-5 px-2 rounded-full text-xs flex items-center justify-center
          ${active ? "bg-blue-100 text-blue-700" : "bg-slate-200 text-slate-600"
                    }`}
            >
                {count}
            </span>
        )}
    </button>
);
const TableWrapper = tw.div`mt-4 bg-white rounded-md `;
const Text = tw.p`text-gray-500 text-sm font-normal `;

export default StampPaperListingNew;